const GC = window.__GENERATED_CONSTANTS__

export const CREATE_TASKS_CONSTANTS = {
    SELECT_CUSTOMER_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
    NEW_CUSTOMER_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX,
    ALL_ACTIVE_CUSTOMERS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX,

    SELECT_PROJECT_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX,
    NEW_PROJECT_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX,
    ALL_ACTIVE_PROJECTS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX,
    SELECTED_PROJECTS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX,

    CUSTOMER_IS_NOT_EXIST_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_EXIST_ERROR,
    CUSTOMER_IS_NOT_ASSIGNED_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_ASSIGNED_ERROR,
    CUSTOMER_EXISTS_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_EXISTS_ERROR,
    CUSTOMER_IS_ARCHIVED_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_ARCHIVED_ERROR,
    NO_ACTIVE_CUSTOMERS_ERROR: GC.CREATE_TASKS_CONSTANTS.NO_ACTIVE_CUSTOMERS_ERROR,

    PROJECT_IS_NOT_EXIST_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_EXIST_ERROR,
    PROJECT_IS_NOT_ASSIGNED_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_ASSIGNED_ERROR,
    PROJECT_EXISTS_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_EXISTS_ERROR,
    PROJECT_IS_ARCHIVED_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_ARCHIVED_ERROR,
    NO_ACTIVE_PROJECTS_ERROR: GC.CREATE_TASKS_CONSTANTS.NO_ACTIVE_PROJECTS_ERROR
}

export const CreateTasksCustomerProjectSelectorErrors = {
    CUSTOMER_EMPTY: "customerEmpty",
    PROJECT_EMPTY: "projectEmpty",
    NO_CUSTOMERS: "noActiveCustomer",
    NO_PROJECTS: "noActiveProject",
    PROJECTS_NOT_SELECTED: "projectsNotSelected",
    CUSTOMER_NOT_SELECTED: "customerNotSelected",
    PROJECT_NOT_SELECTED: "projectNotSelected",
    PROJECT_EXISTS: "projectExists",
    CUSTOMER_EXISTS: "customerExists",
};

export const CreateTasksCustomerProjectSelectorWarnings = {
    NO_CUSTOMERS: "noActiveCustomerWarning",
    NO_PROJECTS: "noActiveProjectWarning",
}



// WEBPACK FOOTER //
// ./web/js/addNewTasks/constants.js